import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { GridFilterInputMultipleSingleSelectProps } from "@mui/x-data-grid-pro";
import { SyntheticEvent, useState } from "react";
import { useTranslation } from "react-i18next";
import { WarningType } from "@/models/Warning";

export default function WarningTypeSelect({
  item,
  applyValue,
}: GridFilterInputMultipleSingleSelectProps) {
  const { t } = useTranslation();

  const [selectedWarnings, setSelectedWarnings] = useState<WarningType[]>(item.value || []);
  const handleWarningChange = (_: SyntheticEvent, newValue: WarningType[]) => {
    setSelectedWarnings(newValue);
    applyValue({ ...item, value: newValue.map(option => option) });
  };
  return (
    <Autocomplete
      multiple
      options={Object.values(WarningType)}
      value={selectedWarnings}
      onChange={handleWarningChange}
      disableCloseOnSelect
      getOptionLabel={option => t(`faultOverview.${option}`)}
      renderOption={(props, option) => (
        <li {...props} key={option}>
          {t(`faultOverview.${option}`)}
        </li>
      )}
      renderInput={params => (
        <TextField
          {...params}
          variant="standard"
          label={t("faultOverview.warningType")}
          placeholder={t("faultOverview.diagnosticPlaceholder")}
          InputProps={{
            ...params.InputProps,
            endAdornment: <>{params.InputProps.endAdornment}</>,
          }}
        />
      )}
    />
  );
}
